// components/settings/InterfacePreferences.tsx
import i18n from "@/common/i18n";
import { DisplayLanguageSelect } from "../components/DisplayLanguageSelect";

export const InterfacePreferences = (): JSX.Element => {
  const currentLanguage = i18n.language;

  const handleLanguageChange = (language: string): void => {
    void i18n.changeLanguage(language).then(() => {
      window.location.reload();
    });
  };

  return (
    <section>
      <div className="grid sm:grid-cols-2 gap-4">
        <DisplayLanguageSelect
          value={currentLanguage}
          onChange={handleLanguageChange}
        />
      </div>
    </section>
  );
};
